module.exports = __webpack_public_path__ + "img/icon-error.d211846a.svg";